export default "__VITE_ASSET__B$o50g_2__"